import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import { showLoading, closeLoading } from '@/utils/loading'
import sign from '@/utils/signature'
import qs from 'qs'
const service = axios.create({
  timeout: 60000,
})
// 全局拦截请求
service.interceptors.request.use(config => {
  showLoading();
  config.headers['X-Frame-Options'] = 'SAMEORIGIN';
  config.headers.zhi_crm_token = localStorage.getItem('zhi_token') || '';
  config.headers.verificationCodeKey = localStorage.getItem('ToUserVerificationCodeKey');
  if(!config.params || !config.params.noData){
    config.headers.villageId = localStorage.getItem('park_data') && JSON.parse(localStorage.getItem('park_data')).id || ""
  }
  
  return sign.configure(config) //业务签名，接口签名加密
}, (error) => Promise.reject(error))
// 全局拦截响应
service.interceptors.response.use(response => {
  closeLoading()
  const json = response.data
  if (json.code == 100 || json.code == 101) {
    Message.error(json.msg)
    localStorage.clear()
    router.push({ name: 'login' })
  } else{
    return json
  }
}, (error) => {
  closeLoading()
  console.log(error)
  if (error.name == 'Error') {
    Message.error(error.msg)
  } else {
    Message.error(error.msg)
  }

  return Promise.reject(error)
})
// ajax entry
const suffix = '' // 后缀
// nginx 大屏代理
const screenProxy = ''
const ajax = function (obj) {
  // loadOpen()
  const _suffix = obj.suffix !== undefined ? obj.suffix : suffix
  const url = screenProxy + obj.url + _suffix
  const type = obj.type ? obj.type.toUpperCase() : 'POST'
  let params = obj.params
  if (obj.qs !== false && type === 'POST') {
    params = qs.stringify(params)
  }else if(obj.qs == false && type === 'POST'){
    var headers = {headers: {'Content-Type': 'application/json'}}
  }
  
  switch (type) {
    case 'GET':
      return service.get(url, { params: params })
    case 'POST':
      return service.post(url, params,headers)
    case 'PUT':
      return service.put(url, params, headers)
    case 'DELETE':
      return service.delete(url, params)
    case 'PATCH':
      return service.patch(url, params, headers)
    default:
  }
}


export default ajax
